import { Platform } from 'react-native';

const isWeb = Platform.OS === 'web';

// Référence pour stocker la fonction navigate de react-router (web)
let webRouterNavigate: ((path: string) => void) | null = null;
// Référence pour stocker l'objet navigation React Native (mobile)
let rnNavigationRef: any = null;

// Fonction pour enregistrer la fonction navigate de react-router
export const setWebRouterNavigate = (navigateFn: (path: string) => void) => {
  webRouterNavigate = navigateFn;
};

// Fonction pour enregistrer l'objet navigation React Native
export const setRNNavigation = (nav: any) => {
  rnNavigationRef = nav;
};

export const navigation = {
  navigate: (route: string, navigationObject?: any, params?: any) => {       
    if (isWeb) {
      // Pour le web, extraire l'écran final depuis params (structure mobile)
      // Ex: params = { screen: 'DemandeAbsence' } ou { screen: 'Autres', params: { screen: 'Actualite' } }
      let targetRoute = route;
      if (params?.screen) {
        // Si c'est une navigation imbriquée (Autres -> Actualite), prendre l'écran le plus profond
        targetRoute = params.params?.screen || params.screen;
      }
      
      if (webRouterNavigate) {
        console.log('[Navigation] Using react-router navigate to:', targetRoute);
        webRouterNavigate(`/${targetRoute}`);
      } else if (typeof window !== 'undefined') {
        console.log('[Navigation] Fallback to window.location.href:', targetRoute);
        window.location.href = `/${targetRoute}`;
      }
    } else {
      // Pour React Native
      const nav = navigationObject || rnNavigationRef;
      if (nav && typeof nav.navigate === 'function') {
        try {
          if (params) {
            nav.navigate(route, params);
          } else {
            nav.navigate(route);
          }          
        } catch (error) {
          console.error(`Erreur de navigation vers ${route}:`, error);
        }
      } else {
        console.warn('Navigation object is not available or invalid');
      }
    }
  },
  
  replace: (route: string, navigation?: any) => {
    if (isWeb) {
      // Pour le web, utiliser react-router si disponible
      const targetRoute = route;
      if (webRouterNavigate) {
        webRouterNavigate(`/${targetRoute}`);
      } else if (typeof window !== 'undefined') {
        window.location.replace(`/${targetRoute}`);
      }
    } else {
      // Pour React Native
      const nav = navigation || rnNavigationRef;
      if (nav && typeof nav.replace === 'function') {
        nav.replace(route);
      } else if (nav && typeof nav.reset === 'function') {
        // Fallback : reset la stack vers l'écran voulu
        nav.reset({ index: 0, routes: [{ name: route }] });
      } else {
        console.warn('L\'objet de navigation n\'est pas disponible ou invalide');
      }
    }
  },
  
  goBack: (navigation?: any) => {
    if (isWeb) {
      // Pour le web, utiliser l'historique du navigateur
      if (typeof window !== 'undefined') {
        window.history.back();
      }
    } else {
      // Pour React Native
      if (navigation && typeof navigation.goBack === 'function') {
        navigation.goBack();
      } else {
        console.warn('L\'objet de navigation n\'est pas disponible ou invalide');
      }
    }
  }
};